import { render, staticRenderFns } from "./PorcentajeAvanceTab.vue?vue&type=template&id=1eb990d0&"
import script from "./PorcentajeAvanceTab.vue?vue&type=script&lang=js&"
export * from "./PorcentajeAvanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports